export default (nextLevel) => {
  if (!nextLevel) {
    return 100;
  }

  const { current, target } = nextLevel.progress;

  if (!target) {
    return 0;
  }

  return Math.min(Math.max((current / target) * 100, 0), 100);
};
